import React, { Component } from 'react';
import TrackLengthComponent from './TrackLengthComponent.js';
import { connect } from "react-redux";
import {setContextualHelp} from "actions/index.js";
import {SAMPLER} from 'constants/track-types.js';
import {setTracksToResample} from 'actions/index.js';
import {setTrackFocused} from 'actions/index.js';
import {setResampleDuration} from 'actions/index.js';
import {RESAMPLE, TRANSCRIBE} from 'constants/contextual-help.js';
import PulseLoader from 'react-spinners/PulseLoader'
import ConditionedComponent from 'components/ConditionedComponent.js';

const RESAMPLE_DURATIONS = [1, 2, 4, 8, 16, 32, 64];

class PianoRollToolbar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            transcribing: false,
        };
    }

    transcribeButton() {
        this.setState({transcribing: true, loadingText: 'Transcribing to MIDI...' });
        setTimeout(() => {
            this.props.sequencerEngine.transcribeIntoMidi(this.props.track)
                .then(
                    () => {
                        this.setState({transcribing: false});
                        this.props.setTrackFocused(this.props.sequencerEngine.tracks.length - 1);
                    });
        }, 100);
    }

    hasTracksToResample() {
        return this.props.tracksToResample !== undefined ?
            this.props.tracksToResample.length > 0 : false;
    }

    isTranscribing() {
        return this.state.transcribing !== undefined && this.state.transcribing;
    }

    isLoading() {
        return this.isTranscribing();

    }

    getLoadingText() {
        if (this.isTranscribing()) {
            return 'Transcribing to MIDI... ';
        } else if (this.hasTracksToResample()) {
            return 'Waiting to resample... ';
        } else if (this.props.isResampling) {
            return 'Resampling... ';
        }
    }

    setContextualHelp(e, contextualHelp) {
        e.stopPropagation(e);
        this.props.setContextualHelp(contextualHelp);
    }

    render() {
        return (
            <div className="piano-roll-toolbar">
              <ConditionedComponent condition={this.props.track.getTrackType() === SAMPLER}>
                <div
                  onMouseOver={(e) => this.setContextualHelp(e, TRANSCRIBE)}
                  onMouseLeave={() => this.props.setContextualHelp(undefined)}
                  draggable={false}
                  onClick={() => this.transcribeButton()}
                  className="transcribe-button">TRANSCRIBE</div>
              </ConditionedComponent>
              <ConditionedComponent condition={this.isLoading()}>
                {this.getLoadingText()}
              </ConditionedComponent>
              <PulseLoader
                sizeUnit={"px"}
                size={10}
                color={'#123abc'}
                loading={this.isLoading()}
                />
              <TrackLengthComponent
                onChange={this.props.onChangeLength}
                resolution={this.props.resolution}
                track={this.props.track}/>
            </div>
        );
    }
}
const mapStateToProps = (state, props) => {
    return {
        tracksToResample: state.tracks.tracksToResample,
        isResampling: state.tracks.isResampling,
        resampleDuration: state.tracks.resampleDuration,
        resolution: state.sequencer.displayResolution,
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return {
        setTracksToResample: (tracks) => dispatch(setTracksToResample(tracks)),
        setTrackFocused: (track) => dispatch(setTrackFocused(track)),
        setResampleDuration: (resampleDuration) => dispatch(setResampleDuration(resampleDuration)),
        setContextualHelp: (element) => dispatch(setContextualHelp(element)),
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(PianoRollToolbar);
